import Vue from 'vue'

import '@/global/index'

// 引入该页面个性化UI组件
import {
  Card, Image, Link, Tabs, TabPane, Breadcrumb, BreadcrumbItem, Divider, Select, Option, InfiniteScroll
} from 'element-ui'

Vue.use(Card)
Vue.use(Image)
Vue.use(Link)
Vue.use(Divider)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Select)
Vue.use(Option)
Vue.use(InfiniteScroll)

import store from '@/store/global-store'
import App from './App'

new Vue({
  store,
  render: h => h(App),
  created: function () {
  }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/seeker/person/c_invited/c_invited.js